import formatDate from '@/helpers/formatDate';

export default function PostDate({
  date,
}) {
  return (
    <div className="text-gray-500 border-l border-green-500 pl-4 leading-tight">
      {formatDate(date, 'short')}
    </div>
  );
}
